import CardDetails from "./CardDetails";
import * as React from "react";
import {useContext} from "react";
import {useTranslation} from "react-i18next";
import {setSnackbar} from "../../../../../../util/state/globalAction";
import {snackbarTypes} from "../../../../../../util/state/globalVariables";
import {useTheftMisappropriationActions} from "../../../../service/useTheftMisappropriationActions";
import {GlobalContext} from "../../../../../../util/state/GlobalContextProvider";
import {useFormContext} from "react-hook-form";

const TabEventDetails = (props: any) => {
    const {t} = useTranslation(['finessecurity'], {keyPrefix: 'theftMisappropriate'});
    const {updateEventCard} = useTheftMisappropriationActions();
    const {dispatchGlobalData} = useContext(GlobalContext);
    const {handleSubmit} = useFormContext();


    const onSubmit = async (payload: any) => {
        let data = await updateEventCard(Object.assign(payload));
        if (data && data.status === "OK") {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t("updateForm.updateMessage"),
                        type: snackbarTypes.success,
                        show: true,
                        autoClose: true,
                    }
                }
            });
            window.location.reload();
        } else {
            dispatchGlobalData({
                type: setSnackbar,
                payload: {
                    snackbar: {
                        message: t("updateForm.updateError"),
                        type: snackbarTypes.error,
                        show: true,
                        autoClose: true,
                    }
                }
            });
        }
    }


    return (

        <form onSubmit={handleSubmit(data => {
            onSubmit({...data});
        }, errors => console.log(errors))} noValidate>
            <CardDetails  setTheftMisappropriate={props.setTheftMisappropriate} theftMisappropriate={props.theftMisappropriate}/>
        </form>
    );
}

export default TabEventDetails;